@if (notification) {
  <div class="alert alert-success">{{ notification }}</div>
}

<div class="card bg-light">
  <div class="card-header">
    <h3>Project creation</h3>
  </div>
  <div class="card-body">
    @if (add_project_msg) {
      <div class="alert alert-success">{{ add_project_msg }}</div>
    }
    @if (add_project_error_msg) {
      <div class="alert alert-danger">{{ add_project_error_msg }}</div>
    }
    <form role="form" class="user-form form-horizonal">
      <div class="form-group row">
        <div class="col-sm-2">
          <label for="project_id">
            Name&nbsp;
            <span style="color: red">(required)&nbsp;</span>
            <span class="glyphicon glyphicon-question-sign" title="Unique name for the project" tooltip></span>
          </label>
          <input placeholder="project name" type="text" id="project_id" [ngModelOptions]="{ standalone: true }" [(ngModel)]="new_project.id" (ngModelChange)="update_project_on_event($event)" class="form-control" />
        </div>
        <div class="col-sm-2">
          <label for="project_owner">
            Owner&nbsp;
            <span style="color: red">(required)&nbsp;</span>
            <span class="glyphicon glyphicon-question-sign" title="Owner Genouest uid" tooltip> </span>
          </label>
          <select id="project_owner" [ngModelOptions]="{ standalone: true }" [(ngModel)]="new_project.owner" class="form-control">
            @for (user of all_users; track user) {
              <option [value]="user.uid">{{ user.uid }}</option>
            }
          </select>
        </div>
        @if (!config.project || config.project.enable_group) {
          <div class="col-sm-2">
            <label for="project_group">
              Group&nbsp;
              <span style="color: red">(required)&nbsp;</span>
              <span class="glyphicon glyphicon-question-sign" data-html="true" title="Unix group: <br> Project members will be added to it" tooltip> </span>
            </label>
            <select id="project_group" [ngModelOptions]="{ standalone: true }" [(ngModel)]="new_project.group" class="form-control">
              @for (group of groups; track group) {
                <option [value]="group.name">{{ group.name }}</option>
              }
            </select>
          </div>
        }
        @if (!config.project || config.project.enable_group) {
          <div class="col-sm-1">
            <label for="group_create" style="opacity: 0">Create</label>
            <p-button id="group_create" type="button" styleClass=" button-primary" data-bs-toggle="modal" data-bs-target="#group_creation">
              <span class="oi oi-plus" aria-hidden="true"></span>
              <span class="glyphicon glyphicon-question-sign" data-html="true" title="Create a new group for this project" tooltip> </span>
            </p-button>
          </div>
        }
        <div class="col-sm-2">
          <label for="project_size">Size (GB)</label>
          <input placeholder="project size in GB" type="number" id="project_size" [value]="default_size" [ngModelOptions]="{ standalone: true }" [(ngModel)]="new_project.size" class="form-control" />
        </div>
        <div class="col-sm-2">
          <label for="project_cpu">Cpu (Hour)</label>
          <input placeholder="project cpu in Hour" type="number" id="project_cpu" [value]="default_cpu" [ngModelOptions]="{ standalone: true }" [(ngModel)]="new_project.cpu" class="form-control" />
        </div>
        <div class="col-sm-2">
          <label for="project_expire">Expiration date</label>
          <input type="date" id="project_expire" [ngModelOptions]="{ standalone: true }" [(ngModel)]="new_project_expire" class="form-control" />
        </div>
        <div class="col-sm-2">
          <label for="project_org">
            Financing&nbsp;
            <span class="glyphicon glyphicon-question-sign" title="Entity financing the project" tooltip> </span>
          </label>
          <input placeholder="Ex : CNRS" type="text" id="project_org" [ngModelOptions]="{ standalone: true }" [(ngModel)]="new_project.orga" class="form-control" />
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-12">
          <label for="project_description">Description</label>
          <textarea placeholder="A short description for the project" rows="2" id="project_description" [ngModelOptions]="{ standalone: true }" [(ngModel)]="new_project.description" class="form-control"></textarea>
        </div>
      </div>

      <div class="form-group row">
        @if (!config.project || config.project.enable_group) {
          <div class="col-sm-2">
            <label>
              Write permission&nbsp;
              <span class="glyphicon glyphicon-question-sign" data-html="true" title="Write access<br>Group : all members<br>Data manager : owner" tooltip> </span>
            </label>
            <select id="project_access" [ngModelOptions]="{ standalone: true }" [(ngModel)]="new_project.access" class="form-control">
              <option value="Group" [selected]="true">Group</option>
              <option value="Data manager">Data manager</option>
            </select>
          </div>
        }
        <div class="col-sm-3">
          <label>
            Path to project&nbsp;
            <span class="glyphicon glyphicon-question-sign" title="Path to the project folder" tooltip> </span>
          </label>
          <input placeholder="PATH/TO/THE/FOLDER" type="text" id="project_path" [value]="default_path" [ngModelOptions]="{ standalone: true }" [(ngModel)]="new_project.path" class="form-control" />
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-2">
          <label style="opacity: 0">Create</label>
          <p-button severity="success" type="button" (onClick)="add_project()" label="Create project"></p-button>
        </div>
        @if (new_project.uuid && new_project.uuid != '') {
          <div class="col-sm-2">
            <label style="opacity: 0;">Reject</label>
            <app-my-delete-confirm [onConfirm]="reject_project" [data]="" [explainMessage]="true" button_disp="Reject project"></app-my-delete-confirm>
          </div>
        }
        @if (new_project.uuid && new_project.uuid != '') {
          <div class="col-sm-2">
            <label style="opacity: 0;">Edit</label>
            <p-button type="button" (onClick)="edit_project()" label="Save changes"></p-button>
          </div>
        }
        @if (new_project.uuid && new_project.uuid != '') {
          <div class="col-sm-2">
            <label style="opacity: 0">De-select</label>
            <p-button severity="secondary" type="button" (onClick)="new_project = {}" label="Undo selection"></p-button>
          </div>
        }
      </div>
    </form>
  </div>
</div>

<div class="card bg-light">
  <div class="card-header" (click)="requests_visible = !requests_visible" style="cursor: pointer">
    <h3>{{ pending_number }} request(s) waiting</h3>
  </div>

  @if (requests_visible) {
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="card bg-light">
            <div class="card-header">
              <h3>Pending projects</h3>
            </div>
            <div class="card-body">
              <div>
                @if (pending_err_msg) {
                  <div class="alert alert-danger">{{ pending_err_msg }}</div>
                }
                @if (pending_msg) {
                  <div class="alert alert-info">{{ pending_msg }}</div>
                }
              </div>
              <p-table #dtw [(value)]="pending_projects" sortMode="multiple">
                <ng-template pTemplate="header">
                  <tr>
                    <th pSortableColumn="created_at">Request <p-sortIcon field="created_at"></p-sortIcon></th>
                    <th pSortableColumn="id">Project <p-sortIcon field="id"></p-sortIcon></th>
                    <th pSortableColumn="owner">User <p-sortIcon field="owner"></p-sortIcon></th>
                    <th pSortableColumn="expire">Expiration <p-sortIcon field="expire"></p-sortIcon></th>
                    <th pSortableColumn="size">Size (GB) <p-sortIcon field="size"></p-sortIcon></th>
                    <th>Cpu (Hour)</th>
                    <th>Org</th>
                    <th></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-pending>
                  <tr>
                    <td>{{ pending.created_at | date }}</td>
                    <td>{{ pending.id }}</td>
                    <td>
                      <a routerLink="/user/{{pending.owner}}">
                        <span class="p-button p-button-sm p-button-primary">{{ pending.owner }}</span>
                      </a>
                    </td>
                    <td>{{ pending.expire | date }}</td>
                    <td>{{ pending.size }}</td>
                    <td>{{ pending.cpu }}</td>
                    <td>{{ pending.orga }}</td>
                    <td>
                      <p-button severity="info" size="small" type="button" style="margin-right: 0px !important" (onClick)="modify_project(pending)" label="View"></p-button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>

<div class="card bg-light">
  <div class="card-header">
    <h3>All projects</h3>
  </div>
  <div class="card-body">
    <p-table #dtp [value]="projects" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 25, 50]" [globalFilterFields]="['id', 'owner', 'group']" [filterDelay]="0" sortMode="multiple">
      <ng-template pTemplate="caption">
        <div class="table-header">
          List of Projects
          <span class="p-input-icon-right">
            <i class="pi pi-search"></i>
            <input pInputText id="search_projects" type="text" (input)="dtp.filterGlobal($event.target.value, 'contains')" placeholder="Global Search" />
          </span>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="id">Project <p-sortIcon field="id"></p-sortIcon></th>
          <th pSortableColumn="owner">Owner <p-sortIcon field="owner"></p-sortIcon></th>
          @if (!config.project || config.project.enable_group) {
            <th pSortableColumn="group">Group <p-sortIcon field="group"></p-sortIcon></th>
          }
          <th pSortableColumn="path">Path <p-sortIcon field="path"></p-sortIcon></th>
          <th pSortableColumn="size">Size (GB) <p-sortIcon field="size"></p-sortIcon></th>
          <th pSortableColumn="cpu">Cpu (Hour) <p-sortIcon field="cpu"></p-sortIcon></th>
          <th pSortableColumn="created_at">Creation <p-sortIcon field="created_at"></p-sortIcon></th>
          <th pSortableColumn="expire">Expiration <p-sortIcon field="expire"></p-sortIcon></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-project>
        <tr>
          <td>
            <a routerLink="/admin/project/{{ project.id }}">
              <span class="p-button p-button-sm p-button-primary project-name" [title]="project.id">{{ project.id }}</span>
            </a>
          </td>
          <td>
            <a routerLink="/user/{{ project.owner }}">
              <span class="p-button p-button-sm p-button-primary">{{ project.owner }}</span>
            </a>
          </td>
          @if ((!config.project || config.project.enable_group) && project.group) {
            <td>
              <a routerLink="/admin/group/{{ project.group }}">
                <span class="p-button p-button-sm p-button-primary">{{ project.group }}</span>
              </a>
            </td>
          }
          <td>{{ project.path }}</td>
          <td>
            @if (project.current_size) {
              <span>{{ project.current_size }}&#47;</span>
              }{{ project.size }}
              @if (project.current_size) {
                <meter min="0" max="{{ project.size }}" optimum="0" low="{{ project.low_size }}" high="{{ project.high_size }}" value="{{ project.current_size }}"></meter>
              }
            </td>
            <td>
              @if (project.current_cpu) {
                <span>{{ project.current_cpu }}&#47;</span>
                }{{ project.cpu }}
                @if (project.current_cpu) {
                  <meter min="0" max="{{ project.cpu }}" optimum="0" low="{{ project.low_cpu }}" high="{{ project.high_cpu }}" value="{{ project.current_cpu }}"></meter>
                }
              </td>
              <td>{{ project.created_at | date }}</td>
              <td>{{ project.expire | date }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <div class="card bg-light">
      <div class="card-header bg-danger">
        <h3>Expired [{{ expired_projects.length }}]</h3>
      </div>
      <div class="card-body">
        <div class="table-responsive table-striped">
          <p-table #dte [value]="expired_projects" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 25, 50]" [globalFilterFields]="['id', 'owner']" [filterDelay]="0" sortMode="multiple">
            <ng-template pTemplate="caption">
              <div class="table-header">
                List of Expired Projects
                <span class="p-input-icon-right">
                  <i class="pi pi-search"></i>
                  <input pInputText id="search_expired_projects" type="text" (input)="dte.filterGlobal($event.target.value, 'contains')" placeholder="Global Search" />
                </span>
              </div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="id">Project <p-sortIcon field="id"></p-sortIcon></th>
                <th pSortableColumn="owner">Owner <p-sortIcon field="owner"></p-sortIcon></th>
                @if (!config.project || config.project.enable_group) {
                  <th pSortableColumn="group">Group <p-sortIcon field="group"></p-sortIcon></th>
                }
                <th pSortableColumn="path">Path <p-sortIcon field="path"></p-sortIcon></th>
                <th pSortableColumn="size">Size (GB) <p-sortIcon field="size"></p-sortIcon></th>
                <th pSortableColumn="cpu">Cpu (Hour) <p-sortIcon field="cpu"></p-sortIcon></th>
                <th pSortableColumn="created_at">Creation <p-sortIcon field="created_at"></p-sortIcon></th>
                <th pSortableColumn="expire">Expiration <p-sortIcon field="expire"></p-sortIcon></th>
                <th>Nb Notification</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-project>
              <tr>
                <td>
                  <a routerLink="/admin/project/{{ project.id }}">
                    <span class="p-button p-button-sm p-button-primary project-name">{{ project.id }}</span>
                  </a>
                </td>
                <td>
                  <a routerLink="/user/{{ project.owner }}">
                    <span class="p-button p-button-sm p-button-primary">{{ project.owner }}</span>
                  </a>
                </td>
                @if ((!config.project || config.project.enable_group) && project.group) {
                  <td>
                    <a routerLink="/admin/group/{{ project.group }}">
                      <span class="p-button p-button-sm p-button-primary">{{ project.group }}</span>
                    </a>
                  </td>
                }
                <td>{{ project.path }}</td>
                <td>
                  @if (project.current_size) {
                    <span>{{ project.current_size }}&#47;</span>
                    }{{ project.size }}
                    @if (project.current_size) {
                      <meter min="0" max="{{ project.size }}" optimum="0" low="{{ project.low_size }}" high="{{ project.high_size }}" value="{{ project.current_size }}"></meter>
                    }
                  </td>
                  <td>
                    @if (project.current_cpu) {
                      <span>{{ project.current_cpu }}&#47;</span>
                      }{{ project.cpu }}
                      @if (project.current_cpu) {
                        <meter min="0" max="{{ project.cpu }}" optimum="0" low="{{ project.low_cpu }}" high="{{ project.high_cpu }}" value="{{ project.current_cpu }}"></meter>
                      }
                    </td>
                    <td>{{ project.created_at | date }}</td>
                    <td>{{ project.expire | date }}</td>
                    <td>{{ project.expiration_notif }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>


        <!-- Modal -->
        <div class="modal" style="z-index: 1500" id="group_creation" tabindex="-1" role="dialog">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h3 class="panel-title">Group creation</h3>
              </div>
              <div class="modal-body">
                <form role="form" class="user-form form-horizonal">
                  <div class="form-group row">
                    <div class="col-sm-4">
                      <label for="create_group_name">Group Name</label>
                      <input id="create_group_name" type="text" [ngModelOptions]="{ standalone: true }" [(ngModel)]="new_group.name" class="form-control"/>
                    </div>
                    <div class="col-sm-4">
                      <label for="create_group_owner">Owner</label>
                      <input id="create_group_owner" type="text" [ngModelOptions]="{ standalone: true }" [(ngModel)]="new_group.owner" class="form-control"/>
                    </div>
                    <div class="col-sm-4">
                      <label for="create_group_description">Description</label>
                      <input id="create_group_description" type="text" [ngModelOptions]="{ standalone: true }" [(ngModel)]="new_group.description" class="form-control"/>
                    </div>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <p-button severity="primary" size="small" type="button" [disabled]="!new_group.name" data-bs-dismiss="modal" (onClick)="addGroup()" label="Create"></p-button>
                <p-button severity="secondary" size="small" type="button" data-bs-dismiss="modal" label="Close"></p-button>
              </div>
            </div>
          </div>
        </div>
